// removed by extract-text-webpack-plugin
module.exports = {"changePasswordModal":"qempo_RecoverUserModal_changePasswordModal-205pKL8","red":"qempo_RecoverUserModal_red-Cbdlvin","lowerError":"qempo_RecoverUserModal_lowerError-1LSadoX","authForm":"qempo_RecoverUserModal_authForm-30JfQiZ","separated":"qempo_RecoverUserModal_separated-1ePMLte","separator":"qempo_RecoverUserModal_separator-3gzbd2y","submitBtn":"qempo_RecoverUserModal_submitBtn-37ysGAy","modalLoading":"qempo_RecoverUserModal_modalLoading-131z8G5"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth/auth-modals/forgot-password-modal/components/RecoverUserModal/RecoverUserModal.scss
// module id = 1980
// module chunks = 0